import {FC, useMemo} from 'react'
import {useUser} from 'entities/user'
import {SettingsItemList, SettingsSidebarId} from 'pages/settings/config'
import {SidebarItem} from '../sidebarItem'
import styles from './styles.module.scss'

type SettingsSidebarProps = {
  selectedId?: SettingsSidebarId
  onClickItem?: (id: SettingsSidebarId) => void
}
export const SettingsSidebar: FC<SettingsSidebarProps> = ({
  selectedId,
  onClickItem
}) => {
  const {paymentsCount} = useUser()

  const settingList = useMemo(() => {
    const list = paymentsCount > 0 ? SettingsItemList : SettingsItemList.filter(item => item.id !== SettingsSidebarId.BILLING)

    return list.map((item) =>
      <SidebarItem
        key={item.id}
        isActive={selectedId === item.id}
        onClick={() => onClickItem && onClickItem(item.id)}
        label={item.label}
      />
    )
  }, [paymentsCount, selectedId, onClickItem])

  return (
    <div className={styles.sidebar}>
      {settingList}
    </div>
  )
}
